import { render, staticRenderFns } from "./VehicleSummaryBox.vue?vue&type=template&id=792d2c0e&"
import script from "./VehicleSummaryBox.vue?vue&type=script&lang=js&"
export * from "./VehicleSummaryBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports